import $ from "jquery";
import eventManager from "../../store/sqftEventManager";
import Config from "../../store/sqftConfig";
import workspace from "../workspace";
import Cursor from "./cursor";
import MiteredOverlay from "../shapes/overlays/mitered";
import {
  inchesToMm,
  measureDistanceToInches,
  mmToInches,
} from "../../../../helpers/sqftHelper";
import {iconPlusBlue} from "../../../../assetsSQFT";
import store from "../../../../../../store";
import {
  addMiteredSection,
  changeMiteredSection,
  deleteMiteredSection
} from "../../../../../../actions/sqftMiteredFunctions";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import {
  EDGE_LABELS,
  MITERED_OVERLAY_TYPE,
  RESOURCE_ATTACHED_TO_TYPE,
  SIDEBAR_BUTTONS_MENU,
  SIDEBAR_NAVIGATION_BUTTONS
} from "../../../../constants";
import {setSQFTMenuOpened, setSQFTMenuOpenedLock} from "../../../../../../actions/sqftMenuFunctions";
import {attachResource} from "./resourseCanas";
import {getEdgeFeatures} from "../../../../helpers/shapeHelper";
import {getMiterEdgeFeature} from "../../../../helpers/featureHelper";

export default class MiteredController {
  cursor;
  design = {
    imgSrc: iconPlusBlue
  };
  nodes = {
    miteredSectionsHTML: $('#mitered-sections'),
  };
  miteredSections = [];

  createCursor = () => {
    this.cursor = new Cursor();
    this.cursor.setCursorImage(this.design.imgSrc);
    eventManager.setCursor('mitered-select', this, true);
  };

  registerEvents = () => {
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      eventManager.priorities.OVERALL
    );
  };

  onMouseUp = (mousePos) => {
    void mousePos;
    let hoverShape = workspace.getHoverShape();

    if (hoverShape && hoverShape.getHoverSegment) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      if (activeButton !== SIDEBAR_NAVIGATION_BUTTONS.mitered) {
        return
      }

      let seg = hoverShape.getHoverSegment();
      if (seg && seg.isWithMitered() && reduxState.sqftMenuState.activeButton === SIDEBAR_BUTTONS_MENU.delete) {
        seg.deleteMitered();
      } else if(seg && seg.isWithMitered()) {
        void 0;
      } else if (seg && !seg.isWithMitered() && !seg.isWithBumpout() && this.cursor.cursorImage) {
        attachResource(seg, null, RESOURCE_ATTACHED_TO_TYPE.mitered, null, '', null, null, false);

        //additionally attach miter edge to the line
        const miterEdgeFeature = getMiterEdgeFeature();
        if (miterEdgeFeature) {
          const name = miterEdgeFeature.getFeatureName();
          attachResource(seg, null, RESOURCE_ATTACHED_TO_TYPE.edge, miterEdgeFeature.dbFeature.id, name);
        }
        // let attachedTo = workspace.getImagesAttachedTo(seg);
        // if(attachedTo) {
        //   workspace.removeShape(attachedTo);
        // }
        // todo
        // var newLines = [new line(new)];
        // hoverShape.addLines(newLines);
        // hoverShape.splitLine(mousePos,seg);

        //todo fix rotation and remove this
        ////////////////////////////////////////////////
        // var isRotateAngleParts = false;
        // hoverShape.rotateAngleParts.forEach((anglePart) => {
        //   if(anglePart.rotatedAngleValue > 0) {
        //     isRotateAngleParts = true
        //   }
        // });
        // if (isRotateAngleParts) return;
        ///////////////////////////////////

        //let historyCallBack = seg.addMiteredToLine.bind(self, mousePos, this.miteredSections.length + 1); // cursorName, self.cursorImage.image.dataset.id

        //workspace.addImage(this.cursor.cursorImage.image, this.cursor.cursorImage.width /  scale, this.cursor.cursorImage.height / scale, seg, hoverShape, 'mitered', historyCallBack);
        //let miteredSection = historyCallBack();
        //this.addSection(miteredSection);

        //todo
        //this.cursor.deregisterEvents();
        //Menu.removeActiveClassFromAllButtons();

      } else {
        // Menu.openMenu();
        // deregisterEvents();
        // elements.designDefault.click();
      }
    }

    //todo
    this.cursor.checkForRestoreCursor();
  };

  addSection = (miteredSection) => {
    const reduxState = store.getState();
    store.dispatch(addMiteredSection(miteredSection));
    store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.mitered));
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };

  updateSection = (miteredSection) => {
    store.dispatch(changeMiteredSection(miteredSection));
    store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.mitered));
    store.dispatch(setSQFTMenuOpenedLock(true));

    const reduxState = store.getState();
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  }

  deleteSection = (miteredOverlay) => {
    store.dispatch(deleteMiteredSection(miteredOverlay.id));
  };

  createMiteredOverlay = (line) => {
    const reduxState = store.getState();
    const miteredSections = reduxState.sqftMiteredState.miteredSections;

    return new MiteredOverlay(line, miteredSections.length + 1, MITERED_OVERLAY_TYPE.mitered)
  };

  destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(self, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
    }
    //this.hide();
  };

  deregisterEvents() {
    eventManager.resetCursor(this);
    eventManager.removeEvent(this);
    this.cursor ? this.cursor.deregisterEvents() : null;
    Config.highlight.lines = false;
  }

  static getTotalArea = () => {
    let miteredSections = workspace.getMiteredSections();
    let miteredSectionsArea = 0;
    for (let i = 0; i < miteredSections.length; i++) {
      miteredSectionsArea += miteredSections[i] ? miteredSections[i].getMiteredTotalArea() : null;
    }

    return miteredSectionsArea;
  };

  onMeasureUnitChange = () => {
    let miteredSections = workspace.getMiteredSections();
    let miteredSectionsArea = 0;
    for (let i = 0; i < miteredSections.length; i++) {
      let segments = miteredSections[i].getSegments();

      segments.map((segment) => {
        segment.height = Config.measureUnit === "Metric"
          ? inchesToMm(segment.height)
          : mmToInches(segment.height);

        segment.thickness.value = Config.measureUnit === "Metric"
          ? inchesToMm(segment.thickness.value)
          : mmToInches(segment.thickness.value)
      });

      miteredSections[i].heightNumberText.value = segments[0].height
    }

    return miteredSectionsArea;
  };

  getTransformedMeasureUnit = (value) => {
    return Config.measureUnit === "Metric"
      ? measureDistanceToInches(value).millimeters // ? distanceToMillimeters(inchesToMm(segment.length.value))
      : value;
  };

  getEdgesLength = () => {
    let additionalLength = 0;
    const lines = workspace.getLines();
    for (const line of lines) {
      if (line.from.getMiteredFeatureId()) {
        additionalLength += this.getEdgeLengthValue();
      }
    }

    return additionalLength
  }

  getEdgeLengthValue = () => {
    return Config.measureUnit === "Imperial"
      ?  (2 * 33) / 40
      : (2 * 900) / 1000;
  }

  getExportedMiteredEdges = () => {
    let addedEdges = [];
    const lines = workspace.getLines();
    for (const line of lines) {
      const miteredFeatureId = line.from.getMiteredFeatureId();
      if (miteredFeatureId) {
        const edgeLengthValue = this.getEdgeLengthValue();
        const navItems = getEdgeFeatures();
        let edgeFeature = navItems.find(edge => edge.part.dbFeature.id === miteredFeatureId);

        addedEdges.push({
          partId: EDGE_LABELS.edge,
          type: EDGE_LABELS.edge,
          name: workspace.intl.formatMessage({id: edgeFeature.part.dbFeature.sharedFeatureName}),
          featureId: miteredFeatureId,
          segments: 1,
          length: edgeLengthValue,
          area: edgeLengthValue
        });
      }
    }

    return addedEdges
  }
}
